module.exports = __webpack_public_path__ + "/images/shop/icon/logo_kfzteile-com.svg";